/* eslint-disable semi */
/* eslint-disable @typescript-eslint/indent */
/* eslint-disable no-case-declarations */
/* eslint-disable react/display-name */
import React, { FC } from "react";
import { connect } from "react-redux";
import { AppState, CoreState } from "../state";
import * as CoreActions from "../actions/core";
import dayjs from "dayjs";

import { stylesApp } from "../styles/app";
import "@fortawesome/fontawesome-free/css/all.css";

import {
  Button,
  Grid,
  Step,
  StepContent,
  StepLabel,
  Stepper,
} from "@material-ui/core";
import Calculator from "./calculator/Calculator";
import GenderInput from "./calculator/GenderInput";
import BirthDateInput from "./calculator/BirthDateInput";
import ContributionInput from "./calculator/ContributionInput";
import JobInfoInput from "./calculator/JobInfoInput";
import ResultCard from "./result/ResultCard";

import { RetirementResultType } from "./result/helpers/types";
import { Days } from "./calculator/helpers/types";
import {
  periodToDays,
  dateDiff,
  pastDate,
} from "./calculator/helpers/functions";
import {
  pointsRetirement,
  toll50Retirement,
  newRuleRetirement,
} from "./calculator/helpers/retirements";

export type Contribution = { begin: Date | null; end: Date | null };

interface PropsFromState {
  core: CoreState;
}

interface PropsFromDispatch {
  changeContent: typeof CoreActions.changeContent;
}
type AllProps = PropsFromDispatch & PropsFromState;

const App: FC<AllProps> = (props: AllProps) => {
  const classes = stylesApp();
  const today = new Date();
  // eslint-disable-next-line prefer-const
  let { core, changeContent } = props;

  const [activeStep, setActiveStep] = React.useState(0);

  const [gender, setGender] = React.useState("");
  const [birthDate, setBirthDate] = React.useState<Date | null>(null);
  const [beginDate, setBeginDate] = React.useState<Date | null>(null);
  const [beginJob, setBeginJob] = React.useState<Date | null>(null);

  const [contributions, setContributions] = React.useState<Contribution[]>([
    { begin: null, end: null },
  ]);
  const [contributionYears, setContributionYears] = React.useState("");
  const [contributionMonths, setContributionMonths] = React.useState("");
  const [retirements, setRetirements] = React.useState<RetirementResultType[]>(
    []
  );
  const [contributionInputType, setContributionInputType] = React.useState<
    "picker" | "time"
  >("time");

  const [errorMessageGender, setErrorMessageGender] = React.useState("");
  const [errorMessageBirthDate, setErrorMessageBirthDate] = React.useState("");
  const [errorMessageBeginDate, setErrorMessageBeginDate] = React.useState("");
  const [errorMessageBeginJob, setErrorMessageBeginJob] = React.useState("");
  const [errorMessageTotalTime, setErrorMessageTotalTime] = React.useState("");
  const handleChangeGender = (event: React.ChangeEvent<HTMLInputElement>) => {
    setErrorMessageGender("");
    setGender((event.target as HTMLInputElement).value);
  };

  const handleChangeContributionInputType = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setErrorMessageGender("");
    let newValue: "picker" | "time";
    switch ((event.target as HTMLInputElement).value) {
      case "picker":
        newValue = "picker";
        break;
      case "time":
        newValue = "time";
        break;
      default:
        newValue = "picker";
    }
    setContributionInputType(newValue);
    setErrorMessageTotalTime("");
  };

  const handleChangeContributionYears = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    // eslint-disable-next-line prefer-const
    let age =
      birthDate !== null ? dateDiff(today, birthDate) : { years: 0, months: 0 };
    let beginContribution =
      contributionYears !== "" && contributionMonths !== ""
        ? pastDate(Number(contributionYears), Number(contributionMonths))
        : dayjs(today);
    let contributionTime = dateDiff(today, beginContribution.toDate());
    if (age > contributionTime) setErrorMessageTotalTime("");

    if (Number((event.target as HTMLInputElement).value) >= 0)
      setContributionYears((event.target as HTMLInputElement).value);
    else setContributionYears("0");
  };

  const handleChangeContributionMonths = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const value = (event.target as HTMLInputElement).value;
    if (Number(value) >= 0 && Number(value) <= 11)
      setContributionMonths((event.target as HTMLInputElement).value);
    else if (Number(value) > 11) setContributionMonths("11");
    else setContributionMonths("0");
  };

  const handleBirthDateChange = (date: Date | null) => {
    setErrorMessageBirthDate("");
    setBirthDate(date);
  };

  const handleChangeBeginJob = (date: Date | null) => {
    setBeginJob(date);
  };

  const handleContributionChange = (
    date: Date | null,
    index: number,
    type: "begin" | "end"
  ) => {
    console.log(date, index);
    if (type === "begin") {
      contributions[index].begin = date;
    } else {
      contributions[index].end = date;
    }
    setErrorMessageTotalTime("");
  };

  const handleBeginDateChange = (date: Date | null) => {
    setBeginDate(date);
  };

  const handleNext = () => {
    setActiveStep((prevActiveStep): number => {
      switch (prevActiveStep) {
        case 0:
          if (gender === "" || birthDate === null) {
            if (gender === "") setErrorMessageGender("O campo é obrigatório");
            if (birthDate === null)
              setErrorMessageBirthDate("O campo é obrigatório");
            return prevActiveStep;
          } else {
            return prevActiveStep + 1;
          }
        case 1:
          let increment = 1;
          let age: Days = 0;
          if (birthDate !== null) age = dateDiff(today, birthDate);

          const dateBeginPublicService = dayjs(
            beginDate !== null ? beginDate : today
          );
          const dateBeginCurrentJob = dayjs(
            beginJob !== null ? beginJob : today
          );

          if (beginJob === null) {
            setErrorMessageBeginDate("O campo é obrigatório");
            increment = 0;
          } else if (dateBeginCurrentJob.isBefore(dateBeginPublicService)) {
            setErrorMessageBeginDate(
              `A data de inicio no último cargo deve ser depois ou igual a data de inicio no serviço publico (${dateBeginPublicService.format(
                "DD/MM/YYYY"
              )})`
            );
            increment = 0;
          }

          if (contributionInputType === "time") {
            let contributionTime: Days = 0;
            if (contributionYears !== "" && contributionMonths !== "")
              contributionTime = dateDiff(
                today,
                pastDate(
                  Number(contributionYears),
                  Number(contributionMonths)
                ).toDate()
              );
            else {
              setErrorMessageTotalTime(
                "É necessário preencher os anos e os meses"
              );
              increment = 0;
            }

            if (increment === 1) {
              if (contributionTime > age) {
                setErrorMessageTotalTime(
                  "O tempo de contribuição não pode ser maior ou igual ao tempo de vida"
                );
                increment = 0;
              }
            }
          } else {
            let totalContributionTime: Days = 0;
            contributions.forEach((contribution, index) => {
              if (contribution.begin !== null && contribution.end !== null) {
                if (
                  dayjs(contribution.begin).isAfter(dayjs(contribution.end))
                ) {
                  increment = 0;
                  setErrorMessageTotalTime(
                    "A data de término deve ser depois da de início"
                  );
                } else {
                  totalContributionTime += dateDiff(
                    contribution.end,
                    contribution.begin
                  );
                }
              } else {
                increment = 0;
                setErrorMessageTotalTime(
                  "É necessário preencher todos as datas dos períodos"
                );
              }

              if (increment === 1) {
                if (totalContributionTime > age) {
                  setErrorMessageTotalTime(
                    "O tempo de contribuição não pode ser maior ou igual ao tempo de vida"
                  );
                  increment = 0;
                }
              }
            });
          }

          if (increment === 1) {
            changeContent("RESULT_SCREEN");
            computeRetirements();
          }
          return prevActiveStep + increment;
        default:
          return prevActiveStep;
      }
    });
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep): number => {
      return prevActiveStep - 1;
    });
  };

  const computeRetirements = () => {
    let age: Days = 0;
    let jobTime: Days = 0;
    let publicTime: Days = 0;
    let totalContributionTime: Days = 0;
    const date1998 = dayjs(new Date(1998, 11, 16));
    const date2003 = dayjs(new Date(2003, 11, 31));
    const dayEC104_20 = dayjs(new Date(2020, 8, 15));
    const dateBeginPublicService = dayjs(
      beginDate !== null ? beginDate : today
    );

    if (birthDate !== null) age = dateDiff(today, birthDate);
    if (beginDate !== null) publicTime = dateDiff(today, beginDate);
    if (beginJob !== null) jobTime = dateDiff(today, beginJob);
    if (contributionInputType === "time") {
      totalContributionTime = periodToDays(
        Number(contributionYears),
        Number(contributionMonths)
      );
    } else {
      contributions.forEach((contribution, index) => {
        if (contribution.begin !== null && contribution.end !== null) {
          totalContributionTime += dateDiff(
            contribution.end,
            contribution.begin
          );
        }
      });
    }

    retirements.push(
      newRuleRetirement(gender, age, publicTime, jobTime, totalContributionTime)
    );

    if (dayEC104_20.isAfter(dateBeginPublicService)) {
      retirements.push(
        pointsRetirement(
          gender,
          age,
          publicTime,
          jobTime,
          totalContributionTime,
          dateBeginPublicService.isBefore(date1998),
          dateBeginPublicService.isBefore(date2003),
          dateBeginPublicService.isBefore(dayEC104_20)
        )
      );

      retirements.push(
        toll50Retirement(
          gender,
          totalContributionTime,
          publicTime,
          jobTime,
          age,
          dateBeginPublicService.isBefore(date1998),
          dateBeginPublicService.isBefore(date2003),
          dateBeginPublicService.isBefore(dayEC104_20)
        )
      );
    }
  };

  const handleReset = () => {
    setActiveStep(0);
    setGender("");
    setBirthDate(null);
    setContributionYears("");
    setContributionMonths("");
    setContributionInputType("picker");
    changeContent("INPUT_SCREEN");
    setBeginDate(null);
    setBeginJob(null);
    setRetirements([]);
    setContributions([{ begin: null, end: null }]);
    setErrorMessageGender("");
    setErrorMessageBirthDate("");
    setErrorMessageBeginDate("");
    setErrorMessageBeginJob("");
    setErrorMessageTotalTime("");
  };

  return (
    <Calculator>
      {core.content === "INPUT_SCREEN" ? (
        <>
          <Stepper activeStep={activeStep} orientation="vertical">
            <Step key={1}>
              <StepLabel className={classes.stepLabel}>
                Informações Básicas
              </StepLabel>
              <StepContent>
                <Grid
                  alignContent="center"
                  justify="space-around"
                  container
                  spacing={3}
                >
                  <Grid
                    alignContent="center"
                    justify="center"
                    container
                    item
                    xs={12}
                    md={6}
                    spacing={3}
                  >
                    <GenderInput
                      gender={gender}
                      errorMessageGender={errorMessageGender}
                      handleChangeGender={handleChangeGender}
                    />
                  </Grid>
                  <Grid
                    alignContent="center"
                    justify="center"
                    container
                    item
                    xs={12}
                    md={6}
                    spacing={3}
                  >
                    <BirthDateInput
                      birthDate={birthDate}
                      errorMessageBirthDate={errorMessageBirthDate}
                      handleBirthDateChange={handleBirthDateChange}
                    />
                  </Grid>
                </Grid>
                <div className={classes.actionsContainer}>
                  <div>
                    <Button
                      variant="contained"
                      onClick={handleNext}
                      className={classes.buttonNext}
                    >
                      Próximo
                    </Button>
                  </div>
                </div>
              </StepContent>
            </Step>
            <Step key={2}>
              <StepLabel className={classes.stepLabel}>
                Informações Adicionais
              </StepLabel>
              <StepContent>
                <Grid justify="space-around" container spacing={3}>
                  <Grid
                    justify="center"
                    container
                    item
                    xs={12}
                    md={6}
                    spacing={3}
                  >
                    <ContributionInput
                      inputType={contributionInputType}
                      years={contributionYears}
                      months={contributionMonths}
                      contributions={contributions}
                      errorMessageTotalTime={errorMessageTotalTime}
                      handleChangeInputType={handleChangeContributionInputType}
                      handleChangeYears={handleChangeContributionYears}
                      handleContributionChange={handleContributionChange}
                      handleChangeMonths={handleChangeContributionMonths}
                    />
                  </Grid>
                  <Grid
                    justify="center"
                    container
                    item
                    xs={12}
                    md={6}
                    spacing={3}
                  >
                    <JobInfoInput
                      beginDate={beginDate}
                      beginJob={beginJob}
                      errorMessageBeginDate={errorMessageBeginDate}
                      errorMessageBeginJob={errorMessageBeginJob}
                      handleBeginDateChange={handleBeginDateChange}
                      handleChangeBeginJob={handleChangeBeginJob}
                    />
                  </Grid>
                </Grid>

                <div className={classes.actionsContainer}>
                  <div>
                    <Button onClick={handleBack} className={classes.buttonBack}>
                      Anterior
                    </Button>
                    <Button
                      variant="contained"
                      onClick={handleNext}
                      className={classes.buttonNext}
                    >
                      Calcular
                    </Button>
                  </div>
                </div>
              </StepContent>
            </Step>
          </Stepper>
        </>
      ) : (
        <div>
          {retirements.map((retirement, index) => {
            return (
              <ResultCard
                key={index}
                title={retirement.title}
                type={retirement.type}
                data={retirement.data}
                restDate={retirement.restDate}
                percentual={retirement.percentual}
                leftTimeFull={
                  retirement.leftTimeFull != null
                    ? retirement.leftTimeFull
                    : undefined
                }
                leftTimeRest={retirement.leftTimeRest}
              />
            );
          })}
          <div className={classes.actionsContainer}>
            <div>
              <Button
                variant="contained"
                onClick={handleReset}
                className={classes.buttonNext}
              >
                Recomeçar
              </Button>
            </div>
          </div>
        </div>
      )}
    </Calculator>
  );
};

const mapStateToProps = ({ core }: AppState) => ({
  core: core,
});

const mapDispatchToProps = {
  changeContent: CoreActions.changeContent,
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
